// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__ipRX9","termsAndPrivacyLink":"Footer_termsAndPrivacyLink__diGNO","termsAndPrivacyLinkButton":"Footer_termsAndPrivacyLinkButton__-mNk8"};